import React from 'react';
import { Link } from 'react-router-dom';
import { projects } from '../constants';
import { FaExternalLinkAlt, FaGithub, FaFolderOpen } from 'react-icons/fa';
import '../styles/projects.scss';

const Projects = () => {
  return (
    <section className="projects-container">
      {/* Header */}
      <div className="projects-header">
        <span className="section-badge">
          <FaFolderOpen /> SELECTED WORK
        </span>
        <h1 className="headline">
          Featured <span className="gradient-text">Projects</span>
        </h1>
      </div>

      {/* Grid */}
      <div className="project-grid">
        {projects.map((project) => {
          // Parse string technologies into tags array if needed
          const techList = Array.isArray(project.Technologies)
            ? project.Technologies
            : project.Technologies
            ? project.Technologies.split(',').map((item) => item.trim())
            : [];

          return (
            <article className="project-card" key={project.name}>
              <div className="card-top">
                <div className={`project-image ${project.theme || ''}`}>
                  <img
                    src={project.iconUrl}
                    alt={`${project.name} icon`}
                    className="project-icon"
                  />
                </div>
                
                {/* External Actions */}
                <div className="card-actions">
                  {project.github && (
                    <a
                      href={project.github}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="icon-btn"
                      title="View GitHub Repository"
                      aria-label="View GitHub Repository"
                    >
                      <FaGithub />
                    </a>
                  )}
                  {project.link && (
                    <Link
                      to={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="icon-btn highlight"
                      title="Visit Live Site"
                      aria-label="Visit Live Site"
                    >
                      <FaExternalLinkAlt />
                    </Link>
                  )}
                </div>
              </div>

              <div className="project-info">
                <h3 className="project-title">{project.name}</h3>
                <p className="project-description">{project.description}</p>

                {/* Tech Tags */}
                {techList.length > 0 && (
                  <div className="tech-tags">
                    {techList.map((tech, idx) => (
                      <span className="tech-tag" key={idx}>
                        {tech}
                      </span>
                    ))}
                  </div>
                )}

                {/* Main Link Footer */}
                <div className="project-link-wrapper">
                  <Link
                    to={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="live-link"
                  >
                    <span>Explore Project</span>
                    <span className="arrow-icon">→</span>
                  </Link>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Projects;